

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 处理时间的工具，如时间戳转格式化
 */
export class TimeUtils {
    //将s换算成时分秒,demo(61s = 1minute 1s);
    public static GetTimeBySeconds(seconds: number): TimeData {
        const t = new TimeData();
        t.day = Math.floor(seconds / 3600 / 24);
        t.hour = Math.floor(seconds / 3600) % 24;
        t.minute = Math.floor((seconds % 3600) / 60);
        t.seconds = Math.floor(seconds % 60);
        return t;
    }

    /**
     * 同上,参数为ms级,较为常用;
     * @param milliseconds
     */
    public static GetTimeStringByMilliseconds(milliseconds: number): string {
        milliseconds = Math.max(milliseconds, 0);
        return TimeUtils.GetTimeStringBySeconds(Math.round(milliseconds / 1000));
    }

    /**
     * 格式化,即不满10的进行补0,通常用于时间显示;
     * eg:value = 2,return 02; value = 12, return 12;
     * @param value
     */
    public static GetFormat(value: number): string {
        if (value < 10) {
            return "0" + value;
        } else {
            return value.toString();
        }
    }

    // 将秒转化成 xx:xx:xx 用于倒计时
    public static GetTimeStringBySeconds(seconds: number): string {
        const timeData = TimeUtils.GetTimeBySeconds(seconds);
        return (
            TimeUtils.GetFormat(timeData.hour) +
            ":" +
            TimeUtils.GetFormat(timeData.minute) +
            ":" +
            TimeUtils.GetFormat(timeData.seconds)
        );
    }

        // 将秒转化成 xx:xx:xx 用于倒计时
    public static GetTimeStringBySecondsPdd(seconds: number): string {
        const timeData = TimeUtils.GetTimeBySeconds(seconds);
        return (
            TimeUtils.GetFormat(timeData.hour + (timeData.day * 24)) +
            ":" +
            TimeUtils.GetFormat(timeData.minute) +
            ":" +
            TimeUtils.GetFormat(timeData.seconds)
        );
    }


    public static GetTimeStringBySecondsPddDay(seconds: number): string {
    const timeData = TimeUtils.GetTimeBySeconds(seconds);

    if (timeData.day > 0) {
        // 包含天数：dd:hh:mm:ss
        return [
            TimeUtils.GetFormat(timeData.day),
            TimeUtils.GetFormat(timeData.hour),
            TimeUtils.GetFormat(timeData.minute),
            TimeUtils.GetFormat(timeData.seconds)
        ].join(':');
    } else {
        // 不显示天数：hh:mm:ss
        return [
            TimeUtils.GetFormat(timeData.hour),
            TimeUtils.GetFormat(timeData.minute),
            TimeUtils.GetFormat(timeData.seconds)
        ].join(':');
    }
}

    //根据指定的时间戳转为对应某个时间的时间戳,time单位为ms;
    public static SwitchToCurDay(time, timeData: TimeData): number {
        const date = new Date(time);
        if (timeData.month != 0) {
            date.setMonth(timeData.month);
        }
        if (timeData.day != 0) {
            date.setDate(timeData.day);
        }
        date.setHours(timeData.hour, timeData.minute, timeData.seconds, 0);
        const newTime = Date.parse(date.toString());
        return newTime;
    }

    /**
     * 转换到星期几的对应时间戳;
     * @param time
     * @param day
     * @param timeData
     * @returns
     */
    public static GetWeekDayTimeStamp(time, day, timeData: TimeData): number {
        const date = new Date(time);
        let realDay = date.getDay();
        if (realDay == 0) {
            realDay = 7;
        }
        //day = day % 7;
        const offset = (day - realDay) * 24 * 60 * 60 * 1000;
        const stamp = this.SwitchToCurDay(time, timeData);
        return stamp + offset;
    }


    /**
     * 从本机获取时间戳;
     */
    public static GetLocalCurTimeStamp() {
        return new Date().getTime();
    }

    /**
     * 根据时间戳获取对应的时间,通常用于显示;
     * @param timeStamp
     */
    public static GetCurTimeByTimeStamp(timeStamp) {
        const date = new Date(timeStamp);
        const Y = date.getFullYear() + "-";
        const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        const h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        const m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
        const s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
    }

    public static GetCurTimeDateByTimeStamp(timeStamp) {
        const t = {
            Y: "",
            M: "",
            D: "",
            h: "",
            m: "",
            s: "",
        };
        const date = new Date(timeStamp);
        t.Y = date.getFullYear().toString();
        t.M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "";
        t.D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "";
        t.h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + "";
        t.m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + "";
        t.s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds() + "";
        return t;
    }

    /**
     * 获取间隔时间的时间戳,返回ms级;
     * @param timeData
     */
    public static GetGapStamp(timeData: TimeData) {
        const day = timeData.day;
        const hour = timeData.hour;
        const minute = timeData.minute;
        const second = timeData.seconds;

        return (day * 24 * 60 * 60 + hour * 60 * 60 + minute * 60 + second) * 1000;
    }

    /**
     * 将倒计时格式化为字符序列
     * @param ms 剩余时间
     * @param reserve > 0 保留模式：从第一个非0大单位，先向后，再向前，尽可能补充指定数量的单位
     * @param reserve 0 非保留模式：只保留非0数值
     * @param lang 按照 天，时，分，秒 的顺序填写翻译文本
     * @returns [1天, 2时...] 这样的数据
     */
    static MakeRemainingTimeStr(ms: number, reserve = 0, lang = ["天", "时", "分", "秒"]): string[] {
        const left = Math.max(0, Math.floor(ms / 1000));
        const td = TimeUtils.GetTimeBySeconds(left);
        const ret: string[] = [];
        const nums = [td.day, td.hour, td.minute, td.seconds];

        if (reserve > 0) {
            // 保留模式，找到第一个大于0的位置
            let idx = nums.findIndex((i) => i > 0);
            if (idx < 0) return ret;
            const tail = nums.length - idx;
            if (reserve > tail) {
                idx = Math.max(idx - (reserve - tail), 0);
            }
            const limit = Math.min(nums.length, idx + reserve);
            for (let i = idx; i < limit; ++i) {
                ret.push(`${nums[i]}${lang[i]}`);
            }
        } else {
            // 非保留模式
            for (let i = 0; i < nums.length; ++i) {
                if (nums[i] > 0) {
                    ret.push(`${nums[i]}${lang[i]}`);
                }
            }
        }

        return ret;
    }

    static IsSameDay(ta: number, tb: number): boolean {
        const da = new Date(ta);
        const db = new Date(tb);
        return da.toLocaleDateString() === db.toLocaleDateString();
    }

    /**
     * 获取明日00:00对应的时间戳 + offset ms的值
     * @param thisDayTs 今日任何一个时间的的时间戳
     * @param offset 相对明日 0 点的偏移
     */
    static GetNextDayWithOffset(thisDayTs: number, offset = 0): number {
        return new Date(thisDayTs).setHours(0, 0, 0, 0) + 86400000 + offset;
    }


    /**
     * 时间戳格式化函数（不使用padStart）
     * @param timestamp 时间戳（毫秒）
     * @returns 格式化后的日期字符串
     */
    static formatTimestamp(timestamp: number, separator: string = '-'): string {
        const date = new Date(timestamp * 1000);

        // 数字补零辅助函数
        const padZero = (num: number): string =>
            num < 10 ? `0${num}` : `${num}`;

        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1);
        const day = padZero(date.getDate());
        const hours = padZero(date.getHours());
        const minutes = padZero(date.getMinutes());
        const seconds = padZero(date.getSeconds());

        return `${year}${separator}${month}${separator}${day} ${hours}:${minutes}:${seconds}`;
    }


        /**
     * 时间戳格式化函数（不使用padStart）
     * @param timestamp 时间戳（毫秒）
     * @returns 格式化后的日期字符串
     */
    static formatTimesDYN(timestamp: number, separator: string = '-'): string {
        const date = new Date(timestamp * 1000);

        // 数字补零辅助函数
        const padZero = (num: number): string =>
            num < 10 ? `0${num}` : `${num}`;

        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1);
        const day = padZero(date.getDate());

        return `${year}${separator}${month}${separator}${day}`;
    }

    static formatTimeTo12Hour(timeStr: string): string {
        // 拆分字符串
        const [hourStr, minuteStr] = timeStr.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);

        // 判断上午/下午
        const period = hour > 12 ? "PM" : "AM";

        // 转换成 12 小时制
        if (hour === 0) {
            hour = 12; // 午夜 00:xx 显示为 12:xxAM
        } else if (hour > 12) {
            hour = hour - 12;
        }

        // 补零
        const hourFormatted = hour.toString().padStart(2, "0");
        const minuteFormatted = minute.toString().padStart(2, "0");

        return `${hourFormatted}:${minuteFormatted}${period}`;
    }
}

//保存当前帧的deltaTime,免得到处传递这个值;
export class GameTimeUtils {
    private static _instance: GameTimeUtils = null;
    public static get instance(): GameTimeUtils {
        if (this._instance == null) {
            this._instance = new GameTimeUtils();
        }
        return this._instance;
    }

    public deltaTime = 0;
}


export class Utility {
    private static timers: Map<number, any> = new Map();

    static scheduleOnce(callback: () => void, delay: number): number {
        const timerId = setTimeout(() => {
            callback();
            this.timers.delete(timerId);
        }, delay * 1000);
        this.timers.set(timerId, null);
        return timerId;
    }

     static scheduleRepeat(callback: () => void, interval: number): number {
        const timerId = setInterval(() => {
            callback();
        }, interval * 1000) as unknown as number;
        this.timers.set(timerId, null);
        return timerId;
    }
    
   static cancelTimer(timerId: number) {
        clearTimeout(timerId);
        clearInterval(timerId); // 安全起见，同时清除 timeout 和 interval
        this.timers.delete(timerId);
    }
}

export class TimeData {
    public month = 0;
    public day = 0;
    public hour = 0;
    public minute = 0;
    public seconds = 0;
}
